<template>
  <div class="container">
    <div class="row">
      <div class="col-12 pt-5">
        <table class="table table-borderless">
          <thead>
            <tr>
              <th>Date</th>
              <th colspan="2">Type d'opération</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orders" v-bind:key="order.id">
              <td width="30%">{{order.createdAt | formatDate}}</td>
              <td width="50%">{{orderType(order)}}</td>
              <td class="table-actions" width="20%">
                <a class="link-2" @click="goOrderHistoryDetail(order.id)">Voir détail ></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import service from './packs/services'

export default {
  data: function () {
    return {
      orders: []
    }
  },
  async mounted() {
    this.orders = await service.getOrders()
  },
  computed: {
  },
  methods: {

    orderType(order) {
      return order.status=='online' ? 'Paiement en ligne' : 'Livraison'
    },

    goOrderHistoryDetail(orderId) {
      this.$router.push({name: 'orders-history-detail', params: {orderId}})
    }
  }
}
</script>

<style scoped>

th {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
}

td {
  font-family: 'Montserrat SemiBold';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}
</style>
